import { getAttributionPayload } from '@payjib/shared'
import type {
  ApiGenericResponse,
  AuthResponse,
  EmailLoginPayload,
  OtpVerifyPayload,
  RequestOtpPayload,
} from '../../typings'

export function emailLoginAction<T = ApiGenericResponse<AuthResponse>>(payload: EmailLoginPayload): Promise<T> {
  const { api } = useApi()
  return api.post<T>('/v1/auth/login/email', { ...payload, ...getAttributionPayload() })
}

// Request OTP code
export function requestOtpAction<T = ApiGenericResponse<unknown>>(payload: RequestOtpPayload): Promise<T> {
  const { api } = useApi()
  return api.post<T>('/v2/auth/otp/request', payload)
}

// Verify OTP code and login
export function verifyOtpAction<T = ApiGenericResponse<AuthResponse>>(payload: OtpVerifyPayload): Promise<T> {
  const { api } = useApi()
  return api.post<T>('/v2/auth/otp/verify', { ...payload, ...getAttributionPayload() })
}
